import {$authHost} from "./index";

export const fetchInternalNews = async () => {
    const {data} = await $authHost.get('api/internal-news');
    return data;
};

export const fetchInternalNewsBySlug = async (slug) => {
    const {data} = await $authHost.get(`api/internal-news/${encodeURIComponent(slug)}`);
    return data;
};

export const fetchAdminInternalNews = async (params = {}) => {
    const {data} = await $authHost.get('api/internal-news/admin', {params});
    return data;
};

export const createAdminInternalNews = async (payload) => {
    const {data} = await $authHost.post('api/internal-news/admin', payload);
    return data;
};

export const updateAdminInternalNews = async (id, payload) => {
    const {data} = await $authHost.put(`api/internal-news/admin/${id}`, payload);
    return data;
};

export const archiveAdminInternalNews = async (id) => {
    const {data} = await $authHost.delete(`api/internal-news/admin/${id}`);
    return data;
};

export const uploadAdminInternalNewsImage = async (formData) => {
    const {data} = await $authHost.post('api/internal-news/admin/upload-image', formData);
    return data;
};
